// extracted by mini-css-extract-plugin
export default {"receipt-config":"receipt-config_receipt-config__vnHaM"};